export default "__VITE_ASSET__Cgv$o$E5__"